
import {
  defineComponent,
  onMounted,
  ref,
  watch,
} from 'vue';
import {
  ConfigProvider,
  Table,
  Popconfirm,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

import { ticketStatus, polutionTypes, } from '@/configs';

import moment from 'moment';
import gridHistory from './gridHistory.vue';
import ticketModal from './modal/ticket.vue';
import { useStore, } from 'vuex';
import {
  deleteHotGrid,
} from '../hotspotGridReq';

export default defineComponent({
  components: {
    ConfigProvider,
    Table,
    Popconfirm,
    gridHistory,
    ticketModal,
  },
  props: {
    gridData: {
      type: Object,
      default: () => ({}),
      require: true,
    },
    gridActive: {
      type: Boolean,
      default: () => false,
      require: true,
    },
    activeGrid: {
      type: Object,
      default: () => ({}),
      require: true,
    },
  },
  setup (props,{ emit, }) {
    const store = useStore();
    // 工单按钮文字
    const ticketBtnText = ref<string>('生成工单');
    const gridDetailData = ref<any>(null);
    // 企业详情表格行配置
    const companyColumns = ref<any[]>([
      {
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        align: 'center',
        slots: { customRender: 'index', },
        width: '15%',
      },
      {
        title: '企业名称',
        dataIndex: 'companyName',
        key: 'companyName',
        align: 'left',
        ellipsis: true,
        width: '55%',
      },
      {
        title: '企业类型',
        dataIndex: 'typeName',
        key: 'typeName',
        align: 'left',
        width: '30%',
      },
    ]);
    // 企业详情表格数据
    const companyTableData = ref<any[]>([]);
    // 超标详情表格行配置
    const exceedColumns = ref<any[]>([
      {
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        align: 'center',
        slots: { customRender: 'index', },
      },
      {
        title: '日期',
        dataIndex: 'issue',
        slots: { customRender: 'issue', },
        key: 'issue',
        align: 'center',
      },
      {
        title: '浓度(μg/m³)',
        dataIndex: 'value',
        key: 'value',
        align: 'center',
      },
    ]);
    // 超标详情表格数据
    const exceedTableData = ref<any[]>([]);
    // 当前选中的tab：1--疑似企业；2-近三个月超标情况；3、工单详情
    const activeTab = ref<number>(1);
    // 当前网格是否点击选中
    const clickActive = ref<boolean>(false);
    // 工单流转记录数据
    const ticketDetail = ref<any>(null);
    // 创建弹窗显隐
    const ticketModalVisible = ref<boolean>(false);
    // 选中工单ID
    const selectOrderID = ref<string>('');
    const ticketModalAction = ref<string>('');
    // 热点网格ID
    const hotGridId = ref<string>('');
    // 工单状态值

    // 选中热点网格
    const curGrid = ref();

    /**
     * @name: 处理工单，出现工单弹窗
     * @msg:
     * @return {*}
     */
    const showTicketDialog = (record:any, curAction:any|null) => {
      ticketModalVisible.value = true;

      /*
       * selectOrderID.value = record.id;
       * ticketModalAction.value = curAction;
       */
    };

    /**
     * @name: 删除热点网格
     * @msg:
     * @return {*}
     */
    const deletHotGrid = () => {
      const params = {
        // regionId: '320125000000',
        id: hotGridId.value,
      };

      deleteHotGrid(params).then(() => {
        emit('updateLeftTable');
        clickActive.value = false;
        // message.success('删除成功');
      });
    };

    /**
     * @name: 点击切换Tab类型，展示不同内容
     * @param type 选中tab类型：1-疑似企业；2-近三个月超标情况；3、工单详情
     * @return {void}
     */
    const handleClickTab = (type:number) => {
      activeTab.value = type;

      emit('tabClick', type);

      if (type === 3) {

        /*
         * ticketDetail.value = props.activeGrid.repairOrderLogs;
         */
      }
    };

    // 更新工单详情
    const updateTicketDetail = () => {
      emit('updateTicketDetail');
    };

    watch(
      () => props.gridData,
      (newValue:any) => {
        if (newValue) {
          gridDetailData.value = newValue;
          const { airHotSpotChnCompanyTypeList, exceedingStandard, } = newValue;

          companyTableData.value = airHotSpotChnCompanyTypeList || [];
          exceedTableData.value = exceedingStandard;

          // 生产工地后才有repairOrderLogs字段
          ticketDetail.value = newValue?.repairOrderLogs;
          if (ticketDetail.value) {
            const { status, } = ticketDetail.value;

            ticketBtnText.value = ticketStatus[status - 1].title;
          } else {
            ticketDetail.value = null;
            ticketBtnText.value = '生成工单';
          }
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );

    watch(
      () => props.gridActive,
      (newValue) => {
        if (newValue) {
          clickActive.value = true;
        } else {
          clickActive.value = false;
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );

    watch(
      () => props.activeGrid,
      (newValue:any) => {
        if (newValue) {
          const { id, address, feature, } = newValue;

          curGrid.value = newValue;

          // ticketDetail.value = newValue.repairOrderLogs;
          hotGridId.value = id;
        }
      },
      {
        deep: true,
      }
    );

    onMounted(() => {
      //
    });

    return {
      zhCN,
      moment,
      companyColumns,
      companyTableData,
      exceedColumns,
      exceedTableData,
      gridDetailData,
      ticketBtnText,
      activeTab,
      clickActive,
      ticketModalVisible,
      ticketDetail,
      selectOrderID,
      ticketModalAction,
      hotGridId,
      curGrid,
      polutionTypes,
      showTicketDialog,
      deletHotGrid,
      handleClickTab,
      updateTicketDetail,
    };
  },
});
